// extracted by mini-css-extract-plugin
export default {"icon":"TokenIcon_icon__5AZBy","inherit":"TokenIcon_inherit__uxUUw"};